import {
  CancelablePromise,
  isCancelablePromise as isCancelablePromiseOrigin,
} from "cancelable-promise";
import { ApiErrorCause } from "../types";

export function isCancelablePromise(
  val?: CancelablePromise | unknown
): val is CancelablePromise {
  return isCancelablePromiseOrigin(val);
}

export function cancelableFetch(
  input: RequestInfo,
  init: RequestInit = {}
): CancelablePromise<Response> {
  return new CancelablePromise<Response>((resolve, reject, onCancel) => {
    const controller = new AbortController();
    const CancelationErr = new Error("Fetch Cancelation");

    onCancel(() => {
      controller.abort();
    });
    return fetch(input, {
      ...init,
      signal: controller.signal,
    })
      .then(
        (res) => {
          return res.ok ? resolve(res) : Promise.reject(res);
        },
        (e) => {
          if (e.name === "AbortError" || controller.signal.aborted)
            return Promise.reject(CancelationErr);
          return Promise.reject(e);
        }
      )
      .catch((rej: Response | Error) => {
        if (rej === CancelationErr) return;
        if (rej instanceof Error) return reject(rej);
        return rej.text().then((text) => {
          const cause: ApiErrorCause = {
            status: rej.status,
            text,
          };
          return reject(
            new Error(`could not request data from ${input}`, { cause })
          );
        });
      });
  });
}
